import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "ds-credit-claim-toast__text"
};
import { computed } from 'vue';
import { activeCreditClaimToast } from '@/composables/useCreditClaimToast';
import { Z_INDEX } from '@/config/zIndex';
export default {
  __name: 'CreditClaimToastHost',
  setup(__props) {
    const toast = computed(() => activeCreditClaimToast.value);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "ds-credit-claim-toast"
      }, {
        default: _withCtx(() => [toast.value ? (_openBlock(), _createElementBlock("div", {
          key: toast.value.id,
          class: "ds-credit-claim-toast",
          role: "status",
          "aria-live": "polite",
          style: _normalizeStyle({
            zIndex: _unref(Z_INDEX).CREDIT_CLAIM_TOAST
          })
        }, [_createElementVNode("p", _hoisted_1, _toDisplayString(toast.value.text), 1)], 4)) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
};